import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "stroketext" }, " Your scrolling content here Delivery, Trust, Efficiency, Speed * Delivery, Trust, Efficiency, Speed * Delivery, Trust, Efficiency, Speed * Delivery, Trust, Efficiency, Speed ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MarqueeText = _resolveComponent("MarqueeText")!

  return (_openBlock(), _createBlock(_component_MarqueeText, {
    class: "text-[40px] py-[3rem] sm:text-[150px]",
    duration: "20"
  }, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }))
}